

let initialState = {
    sliderText: [
        {
            id: 1,
            text: "WE COOKED YOUR DESIRED PIZZA RECIPE",
            yellowText: "Welcome",
            otherText: "A small river Duden flows by their place and supplies it with the necessary regelialia."
        }
        // {
        //     id: 2,
        //     backgroundImg:bg2,
        //     text: "ITALIAN PIZZA",
        //     yellowText: "Crunchy",
        //     otherText: "A small river Duden flows by their place and supplies it with the necessary regelialia."
        // },
        // {
        //     id: 3,
        //     backgroundImg:bg1,
        //     text: "ITALIAN CUISINE",
        //     yellowText: "Delicious",
        //     otherText: "A small river Duden flows by their place and supplies it with the necessary regelialia."
        // }
    ]
}

const homeReducer = (state = initialState) => {
    return state;
}



export default homeReducer;